// App entrypoint
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'react-toastify/dist/ReactToastify.css';
import { initGA } from './hooks/useAnalytics';

// Bust poisoned CDN/browser caches after a bad deploy (2026-08-31)
(window as unknown as { __BALANCIO_BUILD_ID__?: string }).__BALANCIO_BUILD_ID__ = '20260831a';

// Initialize Google Analytics
initGA();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
